import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  subcategories: []
}

const mutations = {  
  SET_SUBCATEGORIES (state, payload) {
    state.subcategories = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  subcategoriesList: (context, id) => {
    return Vue.http.get(`${env.API}/api/subcategory`)    
      .then((response) => {        
        context.commit('SET_SUBCATEGORIES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  byCategoryId: (context, id) => {
    return Vue.http.get(`${env.API}/api/subcategory/by-category/${id}`)    
      .then((response) => {        
        context.commit('SET_SUBCATEGORIES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getSubcatById: (context, id) => {
    return Vue.http.get(`${env.API}/api/subcategory/by-id/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getSubcategories: (state) => state.subcategories
}

export const subcategory = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategory.js